import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { AuthenticationRepository } from 'src/app/core/data/repository';
import { RoutesConstants } from '../common';
import { concatMap, of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class IsAuthenticatedGuard implements CanActivate {
  // constructor
  constructor(private authenticationRepository: AuthenticationRepository, private router: Router) {}
  // --------------

  // canActivate =>
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (this.authenticationRepository.isLoggedIn()) {
      return true;
    } else {
      this.router.navigate(['/' + RoutesConstants.LOGIN_PAGE_URL]);
      return this.authenticationRepository.logout().pipe(
        concatMap((res) => {
          return of(false);
        })
      );
    }
  }
}
